import TableLoading from "../common/Loading/table_loading";
import {
  formatTimestamp,
  getActivityLabel,
  getActivityTone,
  getDeviceName,
  getRentalName,
} from "./utils";

const ActivityFeed = ({
  activity = [],
  loading = false,
  compact = false,
  showDeviceName = true,
  showActor = true,
}) => {
  if (loading) {
    return <div>{TableLoading(5)}</div>;
  }

  if (!activity.length) {
    return <div className="seam-monitoring-empty">No activity found.</div>;
  }

  return (
    <div className={`seam-activity-feed${compact ? " seam-activity-feed-compact" : ""}`}>
      {activity.map((item, index) => {
        const tone = getActivityTone(item);
        const actor = item.actor_label || item.actor_type || null;

        return (
          <div className="seam-activity-row" key={item.id || item.seam_event_id || index}>
            <div className={`seam-activity-marker seam-status-${tone}`} />
            <div className="seam-activity-body">
              <div className="seam-activity-heading">
                <span className={`seam-status-pill seam-status-${tone}`}>
                  {getActivityLabel(item)}
                </span>
                <span className="seam-activity-time">
                  {formatTimestamp(item.occurred_at || item.created_at)}
                </span>
              </div>
              {showDeviceName && (
                <div className="seam-activity-title">
                  {getDeviceName(item)}
                </div>
              )}
              <div className="seam-activity-meta">
                <span>{getRentalName(item)}</span>
                {showActor && actor ? <span>{actor}</span> : null}
                {item.status && item.status !== item.activity_type ? <span>{item.status}</span> : null}
                {item.error ? <span className="seam-text-danger">{item.error}</span> : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityFeed;
